import { Box, Text } from '@chakra-ui/react';
import React from 'react';


export const PermissionDenied = () => (
  <Box p={10} borderRadius="xl" bg="backGround" borderWidth="1px">
    <Text>You do not have permission to access this page.</Text>
  </Box>
);